import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const prevScrollY = useRef(0);

  useEffect(() => {
    // Store the current scroll position before the route changes
    const handleRouteChange = () => {
      prevScrollY.current = window.scrollY;
    };

    // Listen to the 'beforeunload' event for the current route and before a new page loads
    window.addEventListener("beforeunload", handleRouteChange);

    // Determine the scroll position based on the previous scroll
    let scrollToPosition = 0; // Default to top
    if (prevScrollY.current > 480) {
      scrollToPosition = 480;
    }

    window.scrollTo({
      top: scrollToPosition,
      left: 0,
      behavior: "smooth",
    });

    // Clean up the event listener when the component unmounts or the route changes
    return () => {
      window.removeEventListener("beforeunload", handleRouteChange);
    };
  }, [pathname]);

  return null;
};

export default ScrollToTop;
